/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Site_Relation_OwnInputs */

const en_site_relation_own = /** @type {(inputs: Site_Relation_OwnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your own site`)
};

const id_site_relation_own = /** @type {(inputs: Site_Relation_OwnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Situs sendiri`)
};

/**
* | output |
* | --- |
* | "Your own site" |
*
* @param {Site_Relation_OwnInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const site_relation_own = /** @type {((inputs?: Site_Relation_OwnInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Site_Relation_OwnInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_site_relation_own(inputs)
	return en_site_relation_own(inputs)
});